export default "__VITE_ASSET__2aa6cf6b__"